import { useEffect, useMemo } from 'react'
import { useBreadcrumb } from '../contexts/BreadcrumbContext'
import type { BreadcrumbItem } from '../contexts/BreadcrumbContext'

export function useBreadcrumbs(breadcrumbs: BreadcrumbItem[]) {
  const { setBreadcrumbs } = useBreadcrumb()
  
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const memoizedBreadcrumbs = useMemo(() => breadcrumbs, [JSON.stringify(breadcrumbs)])
  
  useEffect(() => {
    setBreadcrumbs(memoizedBreadcrumbs)
    
    return () => {
      setBreadcrumbs([])
    }
  }, [setBreadcrumbs, memoizedBreadcrumbs])
}